import type { ShareBlockNames } from '@/pages/Markets/MarketsComponents/Share/ShareBlock';
import { sanitizeName } from '@/utils/sanitizeName';

export function getMarketBlockTabParam(blockName: ShareBlockNames, index: number, tabName: string) {
  return `${sanitizeName(blockName)}-${index}%3A${sanitizeName(tabName)}`;
}
